import ImageComponent from './Image';
import ImageBackgroundComponent from './ImageBackground';
import TextComponent from './Text';
import AdaptiveTextComponent from './AdaptiveText';
import ViewComponent from './View';
import ContentComponent from './Content';
import ModalComponent from './Modal';
import ZindexViewComponent from './ZindexView';
import ZViewWrapComponent from './ZViewWrap';
import LottieComponent from './Lottie';
// import SlidingScrollerComponent from './SlidingScroller';
import SlidingContentComponent from './SlidingContent';
import KeyboardAvoidComponent from './KeyboardAvoid';
import WeatherAnimationComponent from './WeatherAnimation';
import PayComponent from './PayComponent';

customElements.define('machweb-image', ImageComponent);
customElements.define('machweb-image-background', ImageBackgroundComponent);
customElements.define('machweb-text', TextComponent);
customElements.define('machweb-adtext', AdaptiveTextComponent);
customElements.define('machweb-view', ViewComponent);
customElements.define('machweb-zview', ZindexViewComponent);
customElements.define('machweb-zviewwrap', ZViewWrapComponent);
customElements.define('machweb-content', ContentComponent);
customElements.define('machweb-modal', ModalComponent);
customElements.define('machweb-lottie', LottieComponent);
// customElements.define('machweb-sliding-scroller', SlidingScrollerComponent);
customElements.define('machweb-sliding-content', SlidingContentComponent);
customElements.define('machweb-keyboard-avoid', KeyboardAvoidComponent);
customElements.define('machweb-weather-animation', WeatherAnimationComponent);
customElements.define('pay-component', PayComponent);
